import firebase from 'firebase/app'
// import "firebase/auth";
import 'firebase/firestore'

import { store } from './store'

import { resetTodoApp } from './actions/thunks'

import { trivialError } from './utilities'

/* export const firebaseApp = */ firebase.initializeApp({
  apiKey: process.env.REACT_APP_FB_API_KEY,
  authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FB_DATABASE_URL,
  projectId: process.env.REACT_APP_FB_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FB_MESSAGING_SENDER_ID
})

// export const firebaseAuth = firebase.auth();

/*
firebaseAuth.onAuthStateChanged((user) => {
  if(user){
    store.dispatch(initializeTodoApp(user.uid));
  }else{
    store.dispatch(exitTodoApp());
  }
})
*/

/*
export const firebaseUiConfig = { // for StyledFirebaseAuth
  callbacks: {
    signInSuccessWithAuthResult: function(authResult, redirectUrl){
      store.dispatch(initializeTodoApp(authResult.user.uid));

      return false; // no redirect: the redux action is handling that
    },
  },
  signInFlow: "popup",
  //signInSuccessUrl: "/signedIn",
  signInOptions: [
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    firebase.auth.GithubAuthProvider.PROVIDER_ID,
  ],
};
*/

export const firestore = firebase.firestore()
const firestoreSettings = { timestampsInSnapshots: true }
firestore.settings(firestoreSettings)
export const fsRootCollection = process.env.REACT_APP_FS_ROOT_COLLECTION

export function createTodo (title) {
  const { listId } = store.getState().listInfo

  fetch(`/${listId}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ title })
  })
    /* .then(response => {}) */
    .catch(() => {
      return trivialError('client-side fetch: create todo failed')
    })
}

export function updateTodoCompletion (todoId, completed) {
  const { listId } = store.getState().listInfo

  fetch(`/${listId}/${todoId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ completed })
  })
    /* .then(response => {}) */
    .catch(() => {
      return trivialError('client-side fetch: update todo completion failed')
    })
}

export function updateTodoTitle (todoId, newTitle) {
  const { listId } = store.getState().listInfo

  fetch(`/${listId}/${todoId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ title: newTitle })
  })
    /* .then(response => {}) */
    .catch(() => {
      return trivialError('client-side fetch: update todo title failed')
    })
}

export function deleteTodo (todoId) {
  const { listId } = store.getState().listInfo

  fetch(`/${listId}/${todoId}`, {
    method: 'DELETE'
  })
    /* .then(response => {}) */
    .catch(() => {
      return trivialError('client-side fetch: create todo failed')
    })
}

export function updateAllTodoCompletion (completed) {
  const { listId } = store.getState().listInfo

  fetch(`/${listId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ type: 'UPDATE_COMPLETION', completed })
  })
    /* .then(response => {}) */
    .catch(() => {
      return trivialError('client-side fetch: update all todos failed')
    })
}

export function deleteCompletedTodos () {
  const { listId } = store.getState().listInfo

  fetch(`/${listId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ type: 'DELETE_COMPLETED' })
  })
    /* .then(response => {}) */
    .catch(() => {
      return trivialError('client-side fetch: delete completed todos failed')
    })
}

export function updateListTitle (newTitle) {
  const { listId } = store.getState().listInfo

  fetch(`/${listId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ type: 'UPDATE_LIST_TITLE', title: newTitle })
  })
    /* .then(response => {}) */
    .catch(() => {
      return trivialError('client-side fetch: update list title failed')
    })
}

export function updateListDescription (newDescription) {
  const { listId } = store.getState().listInfo

  fetch(`/${listId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      type: 'UPDATE_LIST_DESCRIPTION',
      description: newDescription
    })
  })
    /* .then(response => {}) */
    .catch(() => {
      return trivialError('client-side fetch: update list description failed')
    })
}

export function copyTodoList (listId) {
  // fetch
  // on response, redirect
  fetch(`/${listId}/fork`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  })
    .then(response => {
      return response.json()
    })
    .then(urlStr => {
      const listId = new URL(urlStr).pathname.slice(1)
      store.dispatch(resetTodoApp(listId))
    })
    .catch(() => {
      return trivialError('client-side fetch: copy todo list failed')
    })
}

export function getNewTodoList () {
  return fetch('/new', {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  })
    .then(response => {
      return response.json()
    })
    .then(urlStr => {
      return new URL(urlStr).pathname.slice(1)
    })
    .catch(() => {
      return trivialError('client-side fetch: get new todo list failed')
    })
}



// WEBPACK FOOTER //
// ./src/firebase.js